import { mdiAccountOutline } from "@mdi/js"
import { formatPropertyCustomerRole } from "../../../../../../../../../_shared/_logic/customer-roles"
import {
  buildRichTooltip,
  tooltipField,
  tooltipTitle,
} from "../../../../../../../../../../../_shared/_logic/rich-tooltips"

export type ContactComparison = {
  side: string
  label: string
  subLabel?: string
  contactValue?: string
  name?: string
  role?: string
  email?: string
  phone?: string
  unit: string
  origin?: string
  original?: string
  state?: string
  hint?: string
  icon?: string
}
export type ContactPersonDraft = { displayName: string; role: string; email: string; phone: string }
export const personComparison = (
  input: ContactPersonDraft & {
    side: string
    unit: string
    origin?: string
    original?: string
    state?: string
    hint?: string
  },
): ContactComparison => ({
  ...input,
  label: input.displayName || "Kein Ansprechpartner hinterlegt",
  name: input.displayName,
  role: input.role ? formatPropertyCustomerRole(input.role) : "",
  subLabel: [input.role ? formatPropertyCustomerRole(input.role) : "", input.email, input.phone]
    .filter(Boolean)
    .join(" · "),
  icon: mdiAccountOutline,
})
export const comparisonTooltip = (value: ContactComparison): string =>
  buildRichTooltip([
    tooltipTitle(value.side),
    tooltipField("Name", value.name),
    tooltipField("Kontaktwert", value.contactValue || (!value.name ? value.label : "")),
    tooltipField("Rolle", value.role),
    tooltipField("E-Mail", value.email),
    tooltipField("Telefon", value.phone),
    tooltipField("Einheit", value.unit),
    tooltipField("Herkunft", value.origin),
    tooltipField("Entwurfsstatus", value.state),
    tooltipField("Ursprünglich gemeldet", value.original),
    tooltipField("Übernahme", value.hint),
  ])
export const validateContactValue = (kind: string, value: string): string | null => {
  const text = value.trim()

  if (!text) return "Bitte geben Sie einen Kontaktwert ein."

  if (kind === "EMAIL")
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)
      ? null
      : "Bitte geben Sie eine gültige E-Mail-Adresse ein."

  if (kind === "MOBILE" || kind === "FIXED_LINE") {
    const digits = text.replace(/\D/g, "")

    return /^[\d+().\s-]+$/.test(text) && digits.length >= 6 && digits.length <= 15
      ? null
      : "Bitte geben Sie eine gültige Telefonnummer ein (6 bis 15 Ziffern)."
  }

  return "Diese Kontaktart kann hier nicht bearbeitet werden."
}
export const validatePersonContacts = (value: ContactPersonDraft): string | null =>
  (value.email.trim() ? validateContactValue("EMAIL", value.email) : null) ||
  (value.phone.trim() ? validateContactValue("MOBILE", value.phone) : null)
